export default __webpack_public_path__ + "static/media/Wasp Barcode Technologies.acacc17e.png";